import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user submits the account creation form.
 * Event: dental_portal:office_signup:signup_clicked
 */
export function fireSignupClicked(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:signup_clicked', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
